import { useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useGetLengthCheckerProducts = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProducts = async lengthId => {
    setLoading(true);
    setError(null);
    try {
      const response = await customAxios.get(`/Ops/GetLenProduct?lengthId=${lengthId}`, { headers: authHeader() });

      if (response.status === 200) {
        setProducts(response.data || []);
      }
    } catch (err) {
      setError(err.message);
      console.error('Error fetching products:', err);
    } finally {
      setLoading(false);
    }
  };

  // Future CRUD methods - structure ready for implementation
  const addProduct = async (lengthId, productData) => {
    // TODO: POST /Ops/AddLenProduct
    // setProducts([...products, response.data]);
  };

  const updateProduct = async (productId, productData) => {
    // TODO: PUT /Ops/UpdateLenProduct/{productId}
    // setProducts(products.map(p => p.productId === productId ? response.data : p));
  };

  const deleteProduct = async productId => {
    // TODO: DELETE /Ops/DeleteLenProduct/{productId}
    // setProducts(products.filter(p => p.productId !== productId));
  };

  return {
    products,
    loading,
    error,
    fetchProducts,
    // Future CRUD actions
    // addProduct,
    // updateProduct,
    // deleteProduct,
  };
};

export default useGetLengthCheckerProducts;
